/*
 * Widget Templates
 * (Handlebars)
 *
 */
import './utils/lib/handlebars-helpers';
Gryphon = Gryphon || {};
Gryphon.templates = {
  'ai-chat': require('./modules/AIChat/ai-chat.hbs'),
  'displaymax-required-message': require('./components/DisplayMaxRequiredMessage/displaymax-required-message.hbs'),
  dropdown: require('./modules/Dropdown/dropdown.hbs'),
  'dyngrid-check': require('./modules/Dyngrid/dyngrid-check.hbs'),
  dyngrid: require('./modules/Dyngrid/dyngrid.hbs'),
  404: require('./components/NotFound/404.hbs'),
  grid: require('./modules/Grid/grid.hbs'),
  'grid-cell-input': require('./components/GridCellInput/_grid-cell-input.hbs'),
  'grid-skinny': require('./modules/Grid/grid-skinny.hbs'),
  'grid-wide': require('./modules/Grid/grid-wide.hbs'),
  'image-highlight': require('./modules/ImageHighlight/image-highlight.hbs'),
  open_entry: require('./modules/Open/open_entry.hbs'),
  open_trailer: require('./modules/Open/open_trailer.hbs'),
  popup: require('./modules/Popup/popup.hbs'),
  'response-button': require('./components/ResponseButton/_response-button.hbs'),
  'response-item': require('./components/ResponseItem/_response-item.hbs'),
  'dk-partial': require('./components/DkPartial/dk-partial.hbs'),
  'text-highlight': require('./modules/TextHighlight/text-highlight.hbs'),
  'preview-debug-panel': require('./components/PreviewDebugPanel/preview-debug-panel.hbs'),
};
